import { render, staticRenderFns } from "./WritingCreditsSong.vue?vue&type=template&id=6657f680"
import script from "./WritingCreditsSong.vue?vue&type=script&lang=js"
export * from "./WritingCreditsSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports